export enum DocumentTypes {
  identity,
}
